import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import "./about.css";
import { colors } from "styles/colors";


const About = () => {

    // Scroll Animation
    useEffect(() => {
        const elements = document.querySelectorAll(".animate");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));
    }, []);

    return (
        <>
            {/* Hero */}
            <section
                className="position-relative overflow-hidden"
                style={{
                    // background: 'linear-gradient(135deg, #eef2ff 0%, #e8f7f8 50%, #f0f4ff 100%)',
                    background: colors.gradient.soft,
                    padding: 'clamp(2.5rem, 5vw, 4rem) 0 clamp(2rem, 4vw, 3rem)',
                    textAlign: 'center',
                    borderBottomLeftRadius: '30px',
                    borderBottomRightRadius: '30px',
                    marginLeft: 25,
                    marginRight: 25,
                }}
            >
                {/* Decorative elements */}
                <div style={{ position: 'absolute', top: '-80px', left: '-60px', width: '280px', height: '280px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(36,52,125,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-50px', right: '-40px', width: '220px', height: '220px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.08) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <svg style={{ position: 'absolute', top: '30px', right: '8%', opacity: 0.1, pointerEvents: 'none' }} width="70" height="70" viewBox="0 0 70 70" fill="none">
                    {[0, 18, 36, 54].map(x => [0, 18, 36, 54].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#24347D" />))}
                </svg>
                <svg style={{ position: 'absolute', bottom: '40px', left: '6%', opacity: 0.08, pointerEvents: 'none' }} width="50" height="50" viewBox="0 0 50 50" fill="none">
                    {[0, 18, 36].map(x => [0, 18, 36].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#26A2AB" />))}
                </svg>
                {/* Floating ring */}
                <svg style={{ position: 'absolute', top: '25%', left: '12%', opacity: 0.08, pointerEvents: 'none' }} width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <circle cx="25" cy="25" r="20" stroke="#24347D" strokeWidth="2" />
                </svg>

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Pill badge */}
                    <div
                        className="d-inline-flex align-items-center mb-4"
                        style={{
                            gap: '8px',
                            background: 'rgba(36,52,125,0.08)',
                            borderRadius: '50px',
                            padding: '8px 20px',
                            border: '1px solid rgba(36,52,125,0.1)',
                        }}
                    >
                        <FeatherIcon icon="info" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                        <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                            About Us
                        </span>
                    </div>

                    <h1
                        style={{
                            fontSize: 'clamp(2rem, 5vw, 3.2rem)',
                            fontWeight: 800,
                            color: colors.primary.darkBlue,
                            lineHeight: 1.2,
                            marginBottom: '16px',
                        }}
                    >
                        Get to Know{' '}
                        <span
                            style={{
                                color: colors.primary.teal,
                            }}
                        >
                            SalesTrackify
                        </span>
                    </h1>
                    <p
                        style={{
                            fontSize: 'clamp(0.95rem, 1.8vw, 1.12rem)',
                            lineHeight: 1.7,
                            color: '#6b7280',
                            maxWidth: '580px',
                            margin: '0 auto',
                        }}
                    >
                        A smart, scalable CRM platform built by{' '}
                        <strong style={{ color: colors.primary.darkBlue }}>CoreScripts Technologies Ltd</strong>,
                        a UK-based IT company.
                    </p>

                    {/* Decorative line */}
                    <div
                        style={{
                            width: '60px',
                            height: '3px',
                            borderRadius: '2px',
                            background: `linear-gradient(90deg, ${colors.primary.darkBlue}, ${colors.primary.teal})`,
                            margin: '28px auto 0',
                        }}
                    />
                </Container>
            </section>

            {/* Who We Are */}
            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3rem, 6vw, 5rem) 0',
                    background: '#fff',
                }}
            >
                {/* Decorative elements */}
                <svg style={{ position: 'absolute', top: '60px', right: '5%', opacity: 0.06, pointerEvents: 'none' }} width="80" height="80" viewBox="0 0 80 80" fill="none">
                    {[0, 20, 40, 60].map(x => [0, 20, 40, 60].map(y => <circle key={`${x}-${y}`} cx={x + 5} cy={y + 5} r="2.5" fill="#24347D" />))}
                </svg>
                <svg style={{ position: 'absolute', bottom: '40px', left: '4%', opacity: 0.05, pointerEvents: 'none' }} width="60" height="60" viewBox="0 0 60 60" fill="none">
                    {[0, 20, 40].map(x => [0, 20, 40].map(y => <circle key={`${x}-${y}`} cx={x + 5} cy={y + 5} r="2" fill="#26A2AB" />))}
                </svg>
                <div style={{ position: 'absolute', top: '-50px', left: '-30px', width: '200px', height: '200px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.04) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Section header */}
                    <div className="text-center mb-5">
                        <div
                            className="d-inline-flex align-items-center mb-3"
                            style={{ gap: '8px', background: '#eef2ff', borderRadius: '50px', padding: '6px 18px' }}
                        >
                            <FeatherIcon icon="users" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                                Who We Are
                            </span>
                        </div>
                        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3 }}>
                            Empowering Businesses with <span style={{ color: colors.primary.teal }}>Intelligent Sales Solutions</span>
                        </h2>
                    </div>

                    <Row className="align-items-center g-5">
                        {/* LEFT – Image with decorative frame */}
                        <Col lg={6}>
                            <div className="position-relative mx-auto" style={{ maxWidth: '520px' }}>
                                {/* Background accent shape */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '-12px',
                                        left: '-12px',
                                        right: '12px',
                                        bottom: '12px',
                                        borderRadius: '20px',
                                        background: 'linear-gradient(135deg, rgba(36,52,125,0.06) 0%, rgba(38,162,171,0.06) 100%)',
                                        zIndex: 0,
                                    }}
                                />
                                <img
                                    src={require('../../../assets/images/About/Team-pana.png')}
                                    alt="Team"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        borderRadius: '18px',
                                        position: 'relative',
                                        zIndex: 1,
                                    }}
                                />
                            </div>
                        </Col>

                        {/* RIGHT – Content */}
                        <Col lg={6}>
                            <h3 style={{ fontSize: 'clamp(1.3rem, 2.5vw, 1.75rem)', fontWeight: 800, color: '#1a1a2e', marginBottom: '6px' }}>
                                SalesTrackify
                            </h3>
                            <div style={{ width: '50px', height: '3px', background: colors.primary.teal, borderRadius: '2px', marginBottom: '20px' }} />

                            <p style={{ fontSize: '1rem', lineHeight: 1.8, color: '#4b5563', marginBottom: '16px' }}>
                                Designed for small and medium-sized businesses that want a simple,
                                powerful way to manage sales, track leads, and build stronger customer
                                relationships.
                            </p>
                            <p style={{ fontSize: '1rem', lineHeight: 1.8, color: '#4b5563', marginBottom: '28px' }}>
                                Whether you sell services, products, or a mix of both, SalesTrackify
                                provides an end-to-end CRM platform that keeps your team organized and
                                your pipeline visible.
                            </p>

                            {/* Key highlights */}
                            <div className="d-flex flex-column" style={{ gap: '12px', marginBottom: '28px' }}>
                                {[
                                    { icon: 'trending-up', text: 'Smart lead tracking & pipeline management', accent: '#3b82f6' },
                                    { icon: 'refresh-cw', text: 'Automated workflows & follow-ups', accent: '#10b981' },
                                    { icon: 'bar-chart-2', text: 'Real-time analytics & reporting', accent: '#f59e0b' },
                                ].map((item, i) => (
                                    <div key={i} className="d-flex align-items-center" style={{ gap: '12px' }}>
                                        <div
                                            className="d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{
                                                width: '36px',
                                                height: '36px',
                                                borderRadius: '10px',
                                                background: `${item.accent}12`,
                                            }}
                                        >
                                            <FeatherIcon icon={item.icon} style={{ width: '16px', height: '16px', color: item.accent }} />
                                        </div>
                                        <span style={{ fontSize: '0.92rem', fontWeight: 500, color: '#374151' }}>{item.text}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Company info card */}
                            <div
                                style={{
                                    background: '#fafbfc',
                                    borderRadius: '14px',
                                    border: '1px solid #eaeaea',
                                    padding: '20px',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = colors.primary.teal;
                                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.05)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#eaeaea';
                                    e.currentTarget.style.boxShadow = 'none';
                                }}
                            >
                                <div className="d-flex align-items-center" style={{ gap: '12px', marginBottom: '12px' }}>
                                    <div
                                        className="d-flex align-items-center justify-content-center flex-shrink-0"
                                        style={{
                                            width: '42px',
                                            height: '42px',
                                            borderRadius: '10px',
                                            background: 'linear-gradient(135deg, #24347D 0%, #26A2AB 100%)',
                                        }}
                                    >
                                        <FeatherIcon icon="code" style={{ width: '18px', height: '18px', color: '#fff' }} />
                                    </div>
                                    <h4 style={{ fontSize: '1.05rem', fontWeight: 700, color: colors.primary.darkBlue, margin: 0 }}>
                                        CoreScripts Technologies Ltd
                                    </h4>
                                </div>
                                <p style={{ fontSize: '0.9rem', lineHeight: 1.7, color: '#6b7280', margin: '0 0 14px' }}>
                                    The product is owned and developed by CoreScripts Technologies Ltd,
                                    a UK-based IT company specializing in bespoke software development,
                                    product engineering, and scalable business solutions.
                                </p>
                                <div
                                    className="d-inline-flex align-items-center"
                                    style={{
                                        padding: '6px 16px',
                                        background: `${colors.primary.teal}12`,
                                        borderRadius: '50px',
                                        gap: '6px',
                                    }}
                                >
                                    <FeatherIcon icon="map-pin" style={{ width: '14px', height: '14px', color: colors.primary.teal }} />
                                    <span style={{ fontSize: '0.82rem', fontWeight: 600, color: colors.primary.teal }}>United Kingdom</span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* Vision / Mission / Purpose */}
            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3rem, 6vw, 5rem) 0',
                    background: '#fafbfc',
                }}
            >
                {/* Decorative dots */}
                <svg style={{ position: 'absolute', top: '40px', left: '4%', opacity: 0.08, pointerEvents: 'none' }} width="70" height="70" viewBox="0 0 70 70" fill="none">
                    {[0, 18, 36, 54].map(x => [0, 18, 36, 54].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#24347D" />))}
                </svg>
                <svg style={{ position: 'absolute', bottom: '30px', right: '3%', opacity: 0.06, pointerEvents: 'none' }} width="50" height="50" viewBox="0 0 50 50" fill="none">
                    {[0, 18, 36].map(x => [0, 18, 36].map(y => <circle key={`${x}-${y}`} cx={x + 4} cy={y + 4} r="2" fill="#26A2AB" />))}
                </svg>

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Section header */}
                    <div className="text-center mb-5">
                        <div
                            className="d-inline-flex align-items-center mb-3"
                            style={{ gap: '8px', background: '#e8f7f8', borderRadius: '50px', padding: '6px 18px' }}
                        >
                            <FeatherIcon icon="compass" style={{ width: '14px', height: '14px', color: colors.primary.teal }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.teal }}>
                                What Drives Us
                            </span>
                        </div>
                        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3 }}>
                            Vision, Mission & Purpose
                        </h2>
                    </div>

                    <Row className="justify-content-center g-4">
                        {[
                            {
                                icon: 'target',
                                label: 'Our Vision',
                                text: 'To be the CRM of choice for small and medium businesses worldwide by offering a platform that adapts to unique processes and scales as businesses grow.',
                                accent: '#f59e0b',
                                accentBg: '#fefce8',
                                borderAccent: '#fde68a',
                            },
                            {
                                icon: 'eye',
                                label: 'Our Mission',
                                text: 'To deliver a secure, high-performance CRM platform that helps companies manage their sales pipeline, improve customer retention and gain real-time visibility.',
                                accent: '#ef4444',
                                accentBg: '#fef2f2',
                                borderAccent: '#fecaca',
                            },
                            {
                                icon: 'heart',
                                label: 'Our Purpose',
                                text: 'Our purpose is to give growing businesses a CRM that is fast, intuitive and easy to adopt. We remove unnecessary complexity so your teams can spend more time building relationships and closing deals.',
                                accent: '#10b981',
                                accentBg: '#ecfdf5',
                                borderAccent: '#a7f3d0',
                            },
                        ].map((item, i) => (
                            <Col xs={12} md={4} key={i}>
                                <div
                                    className="h-100 d-flex flex-column text-center"
                                    style={{
                                        background: '#fff',
                                        borderRadius: '16px',
                                        border: '1px solid #eaeaea',
                                        padding: 'clamp(1.5rem, 3vw, 2rem)',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 14px 36px rgba(0,0,0,0.06)';
                                        e.currentTarget.style.borderColor = item.accent;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.borderColor = '#eaeaea';
                                    }}
                                >
                                    {/* Top accent bar */}
                                    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: item.accent, borderRadius: '16px 16px 0 0' }} />

                                    {/* Icon */}
                                    <div
                                        className="d-flex align-items-center justify-content-center mx-auto mb-3"
                                        style={{
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '16px',
                                            background: item.accentBg,
                                            marginTop: '8px',
                                        }}
                                    >
                                        <FeatherIcon icon={item.icon} style={{ width: '26px', height: '26px', color: item.accent }} />
                                    </div>

                                    {/* Label */}
                                    <h4
                                        style={{
                                            fontSize: '1rem',
                                            fontWeight: 700,
                                            letterSpacing: '0.5px',
                                            textTransform: 'uppercase',
                                            color: colors.primary.darkBlue,
                                            marginBottom: '12px',
                                        }}
                                    >
                                        {item.label}
                                    </h4>

                                    {/* Text */}
                                    <p
                                        className="flex-grow-1 mb-0"
                                        style={{
                                            fontSize: '0.92rem',
                                            lineHeight: 1.7,
                                            color: '#6b7280',
                                        }}
                                    >
                                        {item.text}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* </Container> */}
            <section className="why-choose-clean">
                {/* <Container> */}
                <Row className="justify-content-center">
                    <Col lg={10}>
                        <div className="why-card" style={{ background: "linear-gradient(135deg, #24347D 0%, #26A2AB 100%)" }}>

                            <h2 className="title text-center  text-white">Why Businesses Choose SalesTrackify</h2>
                            <p className="desc  text-white">
                                Built for growing businesses that need a powerful yet easy-to-use CRM.
                                SalesTrackify simplifies sales processes, improves team productivity,
                                and ensures secure, reliable performance.
                            </p>
                            <span className="line"></span>

                            <Row className="mt-5">

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="briefcase" size={28} />
                                        </div>
                                        <h5 className=" text-white">Built for SMEs</h5>
                                        <p className=" text-white">
                                            Designed for small and medium-sized businesses — services,
                                            retail, e-commerce, B2B and more.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="smile" size={28} />
                                        </div>
                                        <h5 className=" text-white">Easy to Use</h5>
                                        <p className=" text-white">
                                            Clean interface with intuitive workflows that help your team
                                            get value from day one.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="layers" size={28} />
                                        </div>
                                        <h5 className=" text-white">Scalable CRM Features</h5>
                                        <p className=" text-white">
                                            Lead capture, pipeline management, automation, reporting —
                                            everything grows with your business.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="shield" size={28} />
                                        </div>
                                        <h5 className=" text-white">Secure & Reliable</h5>
                                        <p className=" text-white">
                                            Built with modern security practices and aligned with GDPR
                                            and UK/EU standards.
                                        </p>
                                    </div>
                                </Col>

                                <Col md={4} className="text-center mb-4">
                                    <div className="why-item">
                                        <div className="icon-circle">
                                            <FeatherIcon icon="users" size={28} />
                                        </div>
                                        <h5 className=" text-white">Backed by Experts</h5>
                                        <p className=" text-white">
                                            Supported by CoreScripts Technologies Ltd with continuous
                                            updates and improvements.
                                        </p>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </Col>
                </Row>
                {/* </Container> */}
            </section>

            {/* About CoreScripts Technologies Ltd */}
            <section
                className="position-relative overflow-hidden"
                style={{
                    padding: 'clamp(3rem, 6vw, 5rem) 0',
                    background: '#fff',
                }}
            >
                {/* Background decoration */}
                <div style={{ position: 'absolute', top: '-60px', right: '-40px', width: '250px', height: '250px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(38,162,171,0.05) 0%, transparent 70%)', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-40px', left: '-30px', width: '200px', height: '200px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(36,52,125,0.04) 0%, transparent 70%)', pointerEvents: 'none' }} />

                <Container className="position-relative" style={{ zIndex: 1 }}>
                    {/* Header */}
                    <div className="text-center mb-5">
                        <div
                            className="d-inline-flex align-items-center mb-3"
                            style={{
                                gap: '8px',
                                background: '#eef2ff',
                                borderRadius: '50px',
                                padding: '6px 18px',
                            }}
                        >
                            <FeatherIcon icon="code" style={{ width: '14px', height: '14px', color: colors.primary.darkBlue }} />
                            <span style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', color: colors.primary.darkBlue }}>
                                The Company Behind SalesTrackify
                            </span>
                        </div>
                        <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1a1a2e', lineHeight: 1.3 }}>
                            About <span style={{ color: colors.primary.teal }}>CoreScripts Technologies Ltd</span>
                        </h2>
                        <p style={{ color: '#6b7280', fontSize: '1rem', maxWidth: '560px', margin: '8px auto 0' }}>
                            A UK-based IT company providing bespoke software solutions and full-cycle product engineering services.
                        </p>
                    </div>

                    <Row className="justify-content-center">
                        <Col lg={10}>
                            {/* Main description */}
                            <div
                                style={{
                                    background: '#fafbfc',
                                    borderRadius: '16px',
                                    border: '1px solid #eaeaea',
                                    padding: 'clamp(1.5rem, 3vw, 2.5rem)',
                                    marginBottom: '20px',
                                }}
                            >
                                <p style={{ fontSize: '1.08rem', lineHeight: 1.8, color: '#374151', margin: 0 }}>
                                    We work with organisations that want to modernise their systems, automate processes
                                    and launch scalable SaaS products.
                                </p>
                            </div>

                            {/* Expertise grid */}
                            <h5 style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: '16px', fontSize: '1.1rem' }}>
                                Our Expertise Includes
                            </h5>
                            <Row className="g-3 mb-4">
                                {[
                                    { icon: 'globe', text: 'Bespoke web and cloud applications', accent: '#3b82f6', bg: '#eef6ff' },
                                    { icon: 'box', text: 'Product engineering and SaaS development', accent: '#8b5cf6', bg: '#f5f3ff' },
                                    { icon: 'git-merge', text: 'Systems integration and API development', accent: '#10b981', bg: '#ecfdf5' },
                                    { icon: 'tool', text: 'Operational tooling and internal platforms', accent: '#f59e0b', bg: '#fefce8' },
                                ].map((item, i) => (
                                    <Col xs={12} sm={6} key={i}>
                                        <div
                                            className="d-flex align-items-center h-100"
                                            style={{
                                                background: '#fff',
                                                border: '1px solid #eaeaea',
                                                borderRadius: '12px',
                                                padding: '16px',
                                                gap: '14px',
                                                transition: 'all 0.25s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = item.accent;
                                                e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = '#eaeaea';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        >
                                            <div
                                                className="d-flex align-items-center justify-content-center flex-shrink-0"
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '10px',
                                                    background: item.bg,
                                                }}
                                            >
                                                <FeatherIcon icon={item.icon} style={{ width: '18px', height: '18px', color: item.accent }} />
                                            </div>
                                            <span style={{ fontSize: '0.92rem', fontWeight: 500, color: '#374151' }}>
                                                {item.text}
                                            </span>
                                        </div>
                                    </Col>
                                ))}
                            </Row>

                            {/* Flagship callout */}
                            <div
                                className="d-flex align-items-start"
                                style={{
                                    background: 'linear-gradient(135deg, #24347D 0%, #26A2AB 100%)',
                                    borderRadius: '14px',
                                    padding: 'clamp(1.2rem, 2.5vw, 1.8rem)',
                                    gap: '14px',
                                }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center flex-shrink-0"
                                    style={{
                                        width: '42px',
                                        height: '42px',
                                        borderRadius: '10px',
                                        background: 'rgba(255,255,255,0.15)',
                                        marginTop: '2px',
                                    }}
                                >
                                    <FeatherIcon icon="award" style={{ width: '20px', height: '20px', color: '#fff' }} />
                                </div>
                                <p style={{ fontSize: '0.95rem', lineHeight: 1.7, color: 'rgba(255,255,255,0.92)', margin: 0 }}>
                                    <strong style={{ color: '#fff' }}>SalesTrackify</strong> is one of our flagship products, reflecting our passion for building
                                    robust, user-focused software that helps businesses grow.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="py-5" style={{ background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)", }}>
                <div className="container text-center">

                    <h2 className="fw-bold mb-3">
                        What’s Next for <span className="text-primary">SalesTrackify</span>
                    </h2>

                    <p className="text-muted col-lg-7 mx-auto mb-4">
                        We are continuously improving SalesTrackify with new CRM features, integrations,
                        and automation — all powered by real customer feedback.
                    </p>

                    <div className="d-flex justify-content-center gap-3 flex-wrap mt-4">
                        {/* <a href="#demo" className="btn btn-primary btn-lg px-4">Book a Demo</a> */}
                        <a href="/contact" className="btn btn-primary btn-lg px-4">Contact Us</a>
                    </div>

                </div>
            </section>
        </>
    );
};

export default About;

